<template>
  <el-dialog
    title="Gerar Ficha do Imóvel"
    @open="reset"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="25%"
  >
    <el-row
      type="flex"
      justify="start"
    >
      <el-select
        v-model="acao"
        size="small"
        style="width: 100%"
      >
        <el-option
          label="Gerar PDF"
          value="GERAR_PDF"
        />
        <el-option
          label="Enviar por Email"
          value="ENVIAR_EMAIL"
        />
      </el-select>
    </el-row>

    <el-row
      type="flex"
      justify="start"
      style="padding-top: 12px;"
    >
      <el-input
        v-if="enviarEmailSelecionado"
        v-model="relatorio.emailParaEnvio"
        placeholder="E-mail"
        size="small"
      />
    </el-row>

    <el-row
      type="flex"
      justify="start"
      style="padding-top: 12px;"
    >
      <el-switch
        v-model="relatorio.exibirImagens"
        active-text="Exibir Imagens"
        size="small"
      />
    </el-row>
    
    <el-row
      type="flex"
      justify="start"
      style="padding-top: 12px;"
    >
      <el-switch
        v-model="relatorio.exibirProprietarios"
        active-text="Exibir Proprietário"
        size="small"
      />
    </el-row>

    <el-row
      type="flex"
      justify="start"
      style="padding-top: 12px;"
    >
      <el-switch
        v-model="relatorio.exibirComplemento"
        active-text="Exibir Complemento do Endereço"
        size="small"
      />
    </el-row>

    <span slot="footer">
      <el-button
        @click="fechar"
        type="danger"
        size="small"
        round
        class="btn-box-shadow">
        Fechar
      </el-button>

      <el-button
        v-if="gerarPdfSelecionado"
        @click="gerar"
        type="success"
        size="small"
        round
        class="btn-box-shadow">
        Gerar
      </el-button>

      <el-button
        v-if="enviarEmailSelecionado"
        @click="enviar"
        type="success"
        size="small"
        round
        class="btn-box-shadow">
        Enviar
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    visibility: Boolean
  },
  data() {
    return {
      acao: "GERAR_PDF",
      relatorio: {
        nome: "FICHA_DO_IMOVEL",
        emailParaEnvio: "",
        exibirImagens: false,
        exibirProprietarios: false,
        exibirComplemento: false
      }
    }
  },
  computed: {
    ...mapState('alugueisImoveisStore', {
      imovel(state) { return state.imovelSelecionado }
    }),

    gerarPdfSelecionado() { return this.acao == "GERAR_PDF" },
    enviarEmailSelecionado() { return this.acao == "ENVIAR_EMAIL" }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('alugueisImoveisStore', [
      'gerarRelatoriosImovel',
      'enviarRelatoriosImovelPorEmail'
    ]),
    reset() {
      this.acao = "GERAR_PDF",
      this.relatorio = {
        nome: "FICHA_DO_IMOVEL",
        emailParaEnvio: "",
        exibirImagens: false,
        exibirProprietarios: false,
        exibirComplemento: false
      }
    },
    enviar() {
      let payload = this.relatorio;
      payload.imovel = { id: this.imovel.id };

      this.showLoading();
      this.enviarRelatoriosImovelPorEmail(payload)
        .then(resultado => {
          switch(resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            case "FALHA":
              this.$message.warning(resultado.mensagem);
              break;
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        })
        .catch(() => {
          this.$message.error("Não foi possível comunicar-se com o servidor");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    gerar() {
      let payload = this.relatorio;
      payload.imovel = { id: this.imovel.id };
      
      this.showLoading();
      this.gerarRelatoriosImovel(payload)
        .then(resultado => {
          switch(resultado.status) {
            case "SUCESSO":
              window.open(resultado.mensagem, '_blank');
              this.fechar();
              break;
            case "FALHA":
              this.$message.warning("Ocorreu um erro ao tentar gerar a Ficha do Imóvel");
          }
        })
        .catch(() => {
          this.$message.error("Não foi possível comunicar-se com o servidor");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    fechar() {
      this.$emit('close');
    }
  }
}
</script>

